/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const ON_KEY_UP_TO_DO_LIST = 'ON_KEY_UP_TO_DO_LIST';
export const ON_KEY_DOWN_TO_DO_LIST = 'ON_KEY_DOWN_TO_DO_LIST';
